import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { LearnView } from "@/features/courses/components/player/learn-view";

export const learnRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/learn",
  component: LearnView,
});
